import { Flex } from '@/new_src/view/components/Flex';

import { GoToPage } from './GoToPage';
import { RowCount } from './RowCount';

type PaginationControlsProps = {
  className?: string;
  currentPage: number;
  totalPages: number;
  pageSize: number;
  onPageChange(page: number): void;
  onPageSizeChange(size: number): void;
  pageSizeOptions?: number[];
};

export const PaginationControls = ({
  className,
  currentPage,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions,
}: PaginationControlsProps) => {
  return (
    <Flex className={className} align="center" gap={24}>
      <GoToPage key={currentPage} currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
      <RowCount pageSize={pageSize} onPageSizeChange={onPageSizeChange} options={pageSizeOptions} />
    </Flex>
  );
};
